module.exports = __webpack_public_path__ + "static/media/IMG_1864.e14df957.JPG";